import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "pagestyle" }
const _hoisted_5 = { class: "dialog-footer" }

import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Users',
  setup(__props) {

  const searchForm = reactive({
    limit:10,
    page:1,
  })
  const form = reactive({
    id:'',
    username: '',
    realname: '',
    repassword: '',
    password:'',
    status:1,
  })
  const baseData = reactive({
    loading:false,
    title:'',
    userbox:false,
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const getList = () => {
    baseData.loading = true
    api.userApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        tableData.data = res.data.data
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const add = (data:any) => {
    baseData.userbox = true
    baseData.title = '创建账号'
    form.id = ''
    form.username = ''
    form.realname = ''
    form.password = ''
    form.repassword = ''
    form.status = 1
  }
  const edit = (data:any) => {
    baseData.userbox = true
    baseData.title = '编辑账号'
    form.id = data.id
    form.username = data.username
    form.realname = data.realname
    form.password = ''
    form.repassword = ''
    form.status = data.status
  }
  const del = (id:number) => {
    baseData.loading = true
    api.userApi.del({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const save = () => {
    const loadingInstance = ElLoading.service({ fullscreen: true })
    api.userApi.save(form).then((res:any)=>{
      loadingInstance.close()
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        baseData.userbox = false
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  onMounted(() => {
    getList()
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_breadcrumb, {
            class: "breadcrumb",
            separator: "/"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
                default: _withCtx(() => [
                  _createTextVNode("工作台")
                ]),
                _: 1
              }),
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("账号列表")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "editbtn",
            onClick: add
          }, {
            default: _withCtx(() => [
              _createTextVNode("新增")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "row-key": "id",
          border: "",
          data: tableData.data,
          style: {"width":"100%","margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "ID",
              width: "60"
            }),
            _createVNode(_component_el_table_column, {
              prop: "username",
              label: "账号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "realname",
              label: "姓名"
            }),
            _createVNode(_component_el_table_column, {
              prop: "ip",
              label: "登录IP"
            }),
            _createVNode(_component_el_table_column, {
              prop: "loginTime",
              label: "登录时间"
            }),
            _createVNode(_component_el_table_column, { label: "状态" }, {
              default: _withCtx((scope) => [
                (scope.row.status == 1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_2, "正常"))
                  : (_openBlock(), _createElementBlock("p", _hoisted_3, "冻结"))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "操作",
              width: "220"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: ($event: any) => (edit(scope.row)),
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("编辑")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: ($event: any) => (del(scope.row.id)),
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, baseData.loading]
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_pagination, {
            "current-page": searchForm.page,
            "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.page) = $event)),
            "page-size": searchForm.limit,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.limit) = $event)),
            layout: "sizes, prev, pager, next",
            total: tableData.total,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: baseData.userbox,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((baseData.userbox) = $event)),
      title: baseData.title
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (baseData.userbox = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: save
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 提交 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: form,
          "label-width": "120"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "账号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.username,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.username) = $event)),
                  autocomplete: "off",
                  maxlength: "150",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "姓名" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.realname,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.realname) = $event)),
                  autocomplete: "off",
                  maxlength: "150",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.password,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.password) = $event)),
                  placeholder: "没密码或不需要更改密码，则无需填写",
                  type: "password",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "重复密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.repassword,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.repassword) = $event)),
                  placeholder: "没密码或不需要更改密码，则无需填写",
                  type: "password",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: form.status,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("正常")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("冻结")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})